import React, { Component } from "react";
import {Link} from "react-router-dom";


class Service1 extends Component {
  render() {
    return (
        <div>
            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>Equipment Maintenance/AMC</h2>
                                <ul className="breadcrumb-links">
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                                        <i className="bx bx-chevron-right" />
                                    </li>
                                    <li>Equipment Maintenance/AMC</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            {/* ===============  faq wrapper start =============== */}
            <div className="faq-wrapper pt-40">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="faq-wrap">
                            <div className="p-timeline-overview">
                              <br/>  <h5>Equipment Maintenance/AMC</h5><br/>
                                <p>&bull; We do Complete Equipment Maintenance / Service works.</p>
                              <p>&bull; We are specialist in Auto Shot Blasting Equipment Maintenance and Dust Extractor Maintenance.</p>
<p>&bull; We do Complete Plant Maintenance work on Annual Maintenance Contract basis.</p>
<p>&bull; We do Managing and Maintaining of all Machinery on site with detailed Schedule Maintenance Procedure and Preventive Maintenance Plan.</p>
<p>&bull; We do Shutdown jobs with preplanned Maintenance Schedule.</p>
<p>&bull; We do support the Technical Issues in Equipment on site.</p>
<p>&bull; We do Trouble Shooting in Equipment on site.</p>

                            </div><br/><br/>



                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* ===============  faq wrapper end =============== */}
        </div>
    );
  }
}

export default Service1;
